import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgAlert() {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [_jsx("path", {
      d: "M13.834 3.99l-1 .012 1-.012zm0 .054l-1 .012.01.736.705.21.286-.958zm4.58 9.512h-1v1h1v-1zm0 0l.924-.382-.255-.618h-.67v1zm1.548 3.753l-.925.382.925-.382zm-15.924 0l.925.382-.925-.382zm1.548-3.753l.924.381.076-.183v-.198h-1zm4.579-9.512l.285.959.706-.21.009-.737-1-.012zm0-.054l1 .012V3.99h-1zm0 0l-1-.013v.013h1zm4.669-.013l-.002-.2h-2l.002.225 2-.025zm0 .055v-.055l-2 .025v.054l2-.024zm-1.285.97a5.417 5.417 0 013.865 5.19h2a7.417 7.417 0 00-5.294-7.106l-.57 1.917zm3.865 5.19v3.364h2v-3.364h-2zm1 2.364v2-2zm2.472 4.372l-1.548-3.754-1.849.763 1.548 3.754 1.85-.763zM19.5 19a1.5 1.5 0 001.387-2.072l-1.849.763A.5.5 0 0119.5 17v2zM4.501 19h14.998v-2H4.501v2zm-1.387-2.072A1.5 1.5 0 004.5 19v-2a.5.5 0 01.462.69l-1.85-.762zm1.547-3.753l-1.547 3.753 1.849.763 1.547-3.754-1.849-.762zm1.925.381v-3.364h-2v3.364h2zm0-3.364a5.417 5.417 0 013.864-5.19l-.57-1.916a7.417 7.417 0 00-5.294 7.106h2zm2.58-6.215l-.001.055 2 .024v-.054l-2-.025zm0 .013h2-2zm.001-.212c0 .064 0 .129-.002.2l2 .024.002-.224h-2zM12 1c-1.536 0-2.833 1.215-2.833 2.778h2c0-.401.344-.778.833-.778V1zm2.832 2.778C14.832 2.215 13.535 1 12 1v2c.488 0 .832.377.832.778h2z",
      fill: "currentColor"
    }, void 0), _jsx("path", {
      d: "M15 19a3 3 0 11-6 0",
      stroke: "currentColor",
      strokeWidth: 2
    }, void 0), _jsx("path", {
      stroke: "currentColor",
      strokeWidth: 1.8,
      d: "M6 14.1h13"
    }, void 0)]
  }), void 0);
}

export default SvgAlert;